import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useBreakpointValue,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import comment from "../../../img/comment.svg";
import delete_vector from "../../../img/deleteVectorRed.svg";
import edit_vector from "../../../img/editVector.svg";
import emptyDiscussion from "../../../img/emptyDiscussion.svg";
import discuss from "../../../img/joindiscuss.svg";
import rarrow from "../../../img/rarrow.svg";
import { IDiscussionTopic } from "../../../models/trainer-discussiontopic.model";
import { getLocalUserProfile } from "../../../services/auth.service";
import coursesService from "../../../services/courses.service";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import trainerRoutes from "../routes";

const TrDiscussions = () => {
  const [discussionTopics, setDiscussionTopics] = useState<
    IDiscussionTopic | any
  >([]);
  // const [memberStatus, setMemberStatus] = useState(false);
  const [updatedTitle, setUpdatedTitle] = useState("");
  const [updatedDescription, setUpdatedDescription] = useState("");
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const params = useParams();
  const course_id: any = params.course_id;
  const user: any = getLocalUserProfile();
  const [sortType, setSortType] = useState("");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const initialRef = useRef(null);
  const finalRef = useRef(null);

  const courseName: null | string = localStorage.getItem("courseName");

  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });
  const modalSize = useBreakpointValue({ base: "xs", sm: "md", md: "lg" });

  const menuLinks = [
    {
      text: "Course Information",
      route: trainerRoutes.trainerCourses.CourseInformationLink(course_id),
      keywords: ["course-information"],
    },
    {
      text: "Announcements",
      route: trainerRoutes.trainerCourses.AnnouncementLink(course_id),
      keywords: ["announcement"],
    },
    {
      text: "My trainees",
      route: trainerRoutes.trainerCourses.TraineesLink(course_id),
      keywords: ["trainees", "my-attendance-list"],
    },
    {
      text: "Event Scheduler",
      route: trainerRoutes.trainerCourses.CalendarLink(course_id),
      keywords: ["calendar"],
    },
    {
      text: "Discussions",
      route: trainerRoutes.trainerCourses.DiscussionLink(course_id),
      keywords: ["discussion", "discussions"],
    },
    {
      text: "Assessments",
      route: trainerRoutes.trainerCourses.AssignmentsLink(course_id),
      keywords: ["assessments", "assignment"],
    },
    {
      text: "Results",
      route: trainerRoutes.trainerCourses.ResultLink(course_id),
      keywords: ["results", "result"],
    },
    {
      text: "Resources",
      route: trainerRoutes.trainerCourses.ResourcesLink(course_id),
      keywords: ["resource", "resources"],
    },
  ];

  const activeLink = (link: string, keywords: string[]) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (keywords.some((keyword) => location.pathname.includes(keyword))) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  const NewDiscussionButton = () => {
    const isSmallScreen = useBreakpointValue({ base: true, md: false });

    return (
      <>
        {isSmallScreen ? (
          <Button
            height="auto"
            onClick={() => createDiscussionTopic()}
            borderRadius={"2px"}
            padding={"7px"}
            colorScheme="red"
            size="sm"
            width={"90px"}
            leftIcon={<FaPlus />}
          >
            NEW
          </Button>
        ) : (
          <Button
            height="auto"
            onClick={() => createDiscussionTopic()}
            borderRadius={"2px"}
            padding={"7px"}
            colorScheme="red"
            size="sm"
          >
            NEW DISCUSSION TOPIC
          </Button>
        )}
      </>
    );
  };

  useEffect(() => {
    if (course_id && user)
      trainercoursesService.getDiscussionTopics(course_id).then((res) => {
        setDiscussionTopics(res.data);
        setLoading(false);
      });
  }, [reload, course_id]);

  const createDiscussionTopic = () => {
    navigate(`/trainer/course/${course_id}/discussion/new-discussion-group`);
  };

  const handleJoinDiscussion = async (discussion_id: any) => {
    const discussionDetails: any = {
      id: discussion_id,
    };
    try {
      if (discussion_id) {
        const joinDiscussionResponse = await coursesService.joinDiscussionTopic(
          discussionDetails,
          discussion_id
        );
        if (joinDiscussionResponse.status === "success") {
          toast({
            title: "Discussion joined",
            description: "You are now a member of this discussion",
            status: "success",
          });
          setReload(!reload);
        }
      }
    } catch (error: any) {
      toast({
        title: "Join Discussion Topic",
        description: `${error.response.data.message}`,
        status: "error",
      });
    }
  };

  const handleReply = (id: any) => {
    navigate(trainerRoutes.trainerCourses.EachDiscussionLink(course_id, id));
  };

  const getDiscussion = (uuid: string) => {
    const specificDiscussion: IDiscussionTopic = discussionTopics.find(
      (each: IDiscussionTopic) => each.uuid.toString() === uuid
    );
    setUpdatedTitle(specificDiscussion.title);
    setUpdatedDescription(specificDiscussion.description);
    onOpen();
  };

  const handleEdit = async (uuid: string) => {
    const updatedTopicDetails: { title: string | any; description?: string } = {
      title: updatedTitle,
      description: updatedDescription,
    };

    const updateDiscussionResponse =
      await trainercoursesService.editDiscussionGroup(
        updatedTopicDetails,
        uuid
      );

    if (updateDiscussionResponse.status === "success") {
      toast({
        title: "Discussion topic updated",
        description: "You have successfully updated this topic",
        status: "success",
      });
      setReload(!reload);
      onClose();
    } else {
      toast({
        title: "Error updating discussion topic",
        description: updateDiscussionResponse.message,
        status: "error",
      });
    }
  };

  const handleDelete = async (uuid: string) => {
    try{
      const deleteDiscussionResponse =
      await trainercoursesService.deleteDiscussionGroup(uuid);

      if (deleteDiscussionResponse.status === "success") {
        toast({
          title: "Discussion topic deleted",
          description: "You have successfully deleted this topic",
          status: "success",
        });
      }
      setReload(!reload);
    }catch(error: any){
      const error_message = error?.response.data.message || "Something went wrong, try again later !";
      toast({
        title: "Error deleting this topic",
        description: error_message,
        status: "error",
      });
    }
  };

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.topic) {
        errors.topic = "Topic is required";
      }
      if (!values.discuss) {
        errors.discuss = "Discussion Topic description is required";
      }
      return errors;
    },
    initialValues: {
      topic: "",
      discuss: "",
    },
    onSubmit: async (values) => {
      try {
      } catch (error) {
        toast({
          title: "Discussion",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }
    },
  });

  const sortRecentFirst = () => {
    setSortType("recent");
    setDiscussionTopics(
      [...discussionTopics].sort((a: any, b: any) => {
        return b.created_at > a.created_at
          ? 1
          : b.created_at === a.created_at
          ? 0
          : -1;
      })
    );
    return discussionTopics;
  };

  const sortOldestFirst = () => {
    setSortType("oldest");
    setDiscussionTopics(
      [...discussionTopics].sort((a: any, b: any) => {
        return a.created_at > b.created_at
          ? 1
          : a.created_at === b.created_at
          ? 0
          : -1;
      })
    );
    return discussionTopics;
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <TrDashboardHeader />
          <Box
            bg="#F9F8F8"
            minHeight="100vh"
            height="auto"
            width="auto"
            pt={"1.5rem"}
            pb={"2rem"}
          >
            {!showSideNav && (
              <HStack
                overflowX="scroll"
                width={"100vw"}
                height={"60px"}
                justifyContent={"space-around"}
                alignItems={"center"}
                fontSize={"13px"}
                padding={"0px 10px"}
                bg="white"
                className="scroll-hidden"
                mt="1.38rem"
                // flex={"no-wrap"}
              >
                {menuLinks.map((link, index) => (
                  <React.Fragment key={index}>
                    <Link
                      onClick={() => navigate(link.route)}
                      cursor={"pointer"}
                      textAlign={"center"}
                      alignContent={"center"}
                      wordBreak={"keep-all"}
                      height={"60px"}
                      width={"max-content"}
                      borderBottom={
                        activeLink(link.route, link.keywords).borderLeft
                      }
                      borderColor={
                        activeLink(link.route, link.keywords).borderColor
                      }
                      color={activeLink(link.route, link.keywords).textColor}
                    >
                      {link.text}
                    </Link>
                    {index < menuLinks.length - 1 && (
                      <Divider orientation="vertical" height="70%" />
                    )}
                  </React.Fragment>
                ))}
              </HStack>
            )}
            <Flex
              width="90%"
              mx="auto"
              pb="120px"
              pt={["50px", "60px", "60px", "80px"]}
            >
              {showSideNav && <TrainerSidenav />}
              <VStack
                width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}
                mx="auto"
              >
                <HStack width={"100%"} height={"2rem"}>
                  <Text
                    as="span"
                    fontSize={["16px", "20px"]}
                    isTruncated
                    maxWidth={["180px", "200px", "350px", "500px"]}
                  >
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text
                    as="span"
                    fontSize={["16px", "16px", "18px", "20px"]}
                    color={"#616161"}
                  >
                    Discussions
                  </Text>
                </HStack>
                <Box
                  width={"100%"}
                  mx="auto"
                  mb="1rem"
                  pb={{
                    lg: "200px",
                    md: "150px",
                    sm: "110px",
                    base: "110px",
                  }}
                  px={{
                    lg: "2.8rem",
                    md: "2.4rem",
                    sm: "2rem",
                    base: "1.4rem",
                  }}
                  pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                  bg="white"
                >
                  <HStack
                    width={"100%"}
                    justifyContent={"space-between"}
                    alignContent={"center"}
                    alignItems={"baseline"}
                  >
                    <Text
                      color="#1E1E1E"
                      fontSize={{
                        lg: "28px",
                        md: "20px",
                        sm: "16px",
                        base: "16px",
                      }}
                      pb={["20px", "30px"]}
                      fontWeight="600"
                    >
                      Discussions{" "}
                    </Text>
                    {/* <Button
                      // width={{
                      //   lg: "auto",
                      //   md: "auto",
                      //   sm: "7.4rem",
                      //   base: "7.4rem",
                      // }}
                      // fontSize={{
                      //   lg: "13px",
                      //   md: "12px",
                      //   sm: "10px",
                      //   base: "10px",
                      // }}
                      // padding={{
                      //   lg: "1rem 1.5rem",
                      //   md: "1rem",
                      //   sm: "0.8rem",
                      //   base: "0.8rem",
                      // }}
                      height="auto"
                      onClick={() => createDiscussionTopic()}
                      borderRadius={"2px"}
                      padding={"7px"}
                      colorScheme="red"
                      size="sm"
                    >
                      NEW DISCUSSION TOPIC
                    </Button> */}
                    <NewDiscussionButton />
                  </HStack>
                  <HStack
                    justifyContent="flex-start"
                    alignContent="center"
                    mb="30px"
                    gap={"0.5rem"}
                  >
                    <Text
                      fontSize={{
                        lg: "16px",
                        md: "15px",
                        sm: "13px",
                        base: "12px",
                      }}
                      color="black"
                    >
                      Sort by:
                    </Text>
                    <Menu>
                      <MenuButton
                        minWidth="5rem"
                        height={["35px"]}
                        fontSize={{
                          lg: "14px",
                          md: "13px",
                          sm: "13px",
                          base: "12px",
                        }}
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        backgroundColor={"transparent"}
                        borderColor={"#9E9E9E"}
                        borderRadius={"2px"}
                        borderWidth={"1px"}
                      >
                        {sortType == "oldest"
                          ? "Oldest"
                          : sortType == "recent"
                          ? "Recent"
                          : "All"}
                      </MenuButton>
                      <MenuList width="5rem">
                        <MenuItem
                          fontSize={{
                            lg: "14px",
                            md: "13px",
                            sm: "13px",
                            base: "12px",
                          }}
                          as={Button}
                          onClick={sortRecentFirst}
                        >
                          Recent First
                        </MenuItem>
                        <MenuItem
                          fontSize={{
                            lg: "14px",
                            md: "13px",
                            sm: "13px",
                            base: "12px",
                          }}
                          as={Button}
                          onClick={sortOldestFirst}
                        >
                          Oldest First
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </HStack>
                  {loading ? (
                    <Loading />
                  ) : discussionTopics.length > 0 ? (
                    <Box>
                      {discussionTopics.map((topic: any, index: any) => (
                        <Flex
                          key={index}
                          cursor="pointer"
                          justifyContent="space-between"
                          mb="30px"
                          pb="20px"
                          pr="20px"
                          py="25px"
                          boxShadow="base"
                        >
                          <HStack
                            spacing={["0.5rem", "1rem"]}
                            // flexDirection={{
                            //   lg: "row",
                            //   md: "row",
                            //   sm: "row",
                            //   base: "column",
                            // }}
                          >
                            <Box
                              mr="10px"
                              ml={{
                                lg: "45px",
                                md: "30px",
                                sm: "20px",
                                base: "10px",
                              }}
                            >
                              <Center
                                display={["none", "flex"]}
                                mx="auto"
                                mb="20px"
                                bg="#C4C4C4"
                                width={{
                                  lg: "88px",
                                  md: "60px",
                                  sm: "40px",
                                  base: "40px",
                                }}
                                height={{
                                  lg: "88px",
                                  md: "60px",
                                  sm: "40px",
                                  base: "40px",
                                }}
                                borderRadius="50%"
                              >
                                <Avatar
                                  width="100%"
                                  height="100%"
                                  borderRadius="50%"
                                  name={topic.user.name}
                                />
                              </Center>
                            </Box>
                            <Box
                              mr="45px"
                              display={["flex"]}
                              flexDirection={"column"}
                            >
                              <Center
                                mr="auto"
                                mb="10px"
                                bg="#C4C4C4"
                                width={{
                                  lg: "88px",
                                  md: "60px",
                                  sm: "40px",
                                  base: "40px",
                                }}
                                height={{
                                  lg: "88px",
                                  md: "60px",
                                  sm: "40px",
                                  base: "40px",
                                }}
                                display={["flex", "none", "none", "none"]}
                                borderRadius="50%"
                              >
                                <Avatar
                                  width="100%"
                                  height="100%"
                                  borderRadius="50%"
                                  name={topic.user.name}
                                />
                              </Center>
                              <Text
                                fontWeight="600"
                                color="#616161"
                                fontSize={{
                                  lg: "16px",
                                  md: "15px",
                                  sm: "14px",
                                  base: "14px",
                                }}
                              >
                                {topic.title}
                              </Text>
                              <Modal
                                initialFocusRef={initialRef}
                                finalFocusRef={finalRef}
                                isOpen={isOpen}
                                onClose={onClose}
                                size={modalSize}
                              >
                                <ModalOverlay />
                                <ModalContent>
                                  <ModalHeader>
                                    Edit Discussion Topic
                                  </ModalHeader>
                                  <ModalCloseButton />
                                  <ModalBody pb={6}>
                                    <FormControl>
                                      <FormLabel>Title</FormLabel>
                                      <Input
                                        ref={initialRef}
                                        placeholder="Title"
                                        value={updatedTitle}
                                        onChange={(event) =>
                                          setUpdatedTitle(event.target.value)
                                        }
                                      />
                                      {isError ? (
                                        <FormErrorMessage>
                                          Title cannot be blank
                                        </FormErrorMessage>
                                      ) : (
                                        ""
                                      )}
                                    </FormControl>
                                    <FormControl mt={4}>
                                      <FormLabel>Description</FormLabel>
                                      <Input
                                        placeholder="Description"
                                        value={updatedDescription}
                                        onChange={(event) =>
                                          setUpdatedDescription(
                                            event.target.value
                                          )
                                        }
                                      />
                                    </FormControl>
                                  </ModalBody>
                                  <ModalFooter>
                                    <Button
                                      onClick={() => handleEdit(topic.uuid)}
                                      backgroundColor="#E53E3E"
                                      color="white"
                                    >
                                      Save
                                    </Button>
                                  </ModalFooter>
                                </ModalContent>
                              </Modal>
                              <Text
                                fontWeight="400"
                                color=" #B9B9B9"
                                mb="10px"
                                fontSize={{
                                  lg: "12px",
                                  md: "11px",
                                  sm: "10px",
                                  base: "10px",
                                }}
                              >
                                Posted {moment(topic.created_at).fromNow()} by{" "}
                                {topic.user.name}
                                <Text
                                  as="span"
                                  fontSize={{
                                    lg: "10px",
                                    md: "9px",
                                    sm: "8px",
                                    base: "8px",
                                  }}
                                  padding="0.2rem"
                                  bgColor="#FFF4F4"
                                  color="red"
                                  borderRadius="4px"
                                  letterSpacing={"0.5px"}
                                  marginLeft={"0.3rem"}
                                  fontWeight={"700"}
                                >
                                  {" "}
                                  {topic.user.category}
                                </Text>
                              </Text>
                              <HStack
                                fontSize={{
                                  lg: "12px",
                                  md: "11px",
                                  sm: "10px",
                                  base: "10px",
                                }}
                                fontWeight="400"
                                color="  #AEAEAE"
                                mb="10px"
                              >
                                {topic.members?.find(
                                  (member: { uuid: any }) =>
                                    member.uuid === user.uuid
                                ) ? (
                                  <HStack>
                                    <HStack
                                      mx="0.5rem"
                                      cursor="pointer"
                                      onClick={() => handleReply(topic.id)}
                                    >
                                      <Image
                                        src={comment}
                                        width="18px"
                                        height="18px"
                                      />
                                      <Text> reply</Text>
                                    </HStack>
                                    {topic?.user?.uuid === user.uuid && (
                                      <>
                                        <HStack
                                          mx="0.5rem"
                                          cursor="pointer"
                                          onClick={() =>
                                            getDiscussion(topic.uuid)
                                          }
                                        >
                                          <Image
                                            src={edit_vector}
                                            width="18px"
                                            height="18px"
                                          />
                                          <Text> edit</Text>
                                        </HStack>
                                        <HStack
                                          mx="0.5rem"
                                          cursor="pointer"
                                          onClick={() =>
                                            handleDelete(topic.uuid)
                                          }
                                        >
                                          <Image
                                            src={delete_vector}
                                            width="18px"
                                            height="18px"
                                          />
                                          <Text> delete</Text>
                                        </HStack>
                                      </>
                                    )}

                                    {topic.discussions_count > 0 ? (
                                      <HStack
                                        mt="15px"
                                        display={{
                                          lg: "none",
                                          md: "none",
                                          sm: "flex",
                                          base: "flex",
                                        }}
                                      >
                                        <Image src={comment} />
                                        {topic.discussions_count > 1 ? (
                                          <Text>
                                            {topic.discussions_count} replies
                                          </Text>
                                        ) : (
                                          <Text>
                                            {topic.discussions_count} reply
                                          </Text>
                                        )}
                                      </HStack>
                                    ) : (
                                      ""
                                    )}
                                  </HStack>
                                ) : (
                                  <HStack
                                    onClick={() =>
                                      handleJoinDiscussion(topic.id)
                                    }
                                  >
                                    <Image src={discuss} />
                                    <Text>Join Discussion</Text>
                                  </HStack>
                                )}
                              </HStack>
                              <Text
                                fontSize={{
                                  lg: "14px",
                                  md: "13px",
                                  sm: "12px",
                                  base: "12px",
                                }}
                                fontWeight="400"
                                color=" #B9B9B9"
                              >
                                {topic.description.slice(0, 200)}...
                              </Text>
                            </Box>
                          </HStack>
                          <Box
                            display={{
                              lg: "block",
                              md: "block",
                              sm: "none",
                              base: "none",
                            }}
                          >
                            <AvatarGroup
                              size={{
                                lg: "md",
                                md: "sm",
                                sm: "sm",
                                base: "xs",
                              }}
                              max={2}
                            >
                              {topic.members
                                ? topic.members.map((each: any, index: any) => (
                                    <Avatar
                                      key={index}
                                      name={each.name}
                                      src="https://bit.ly/broken-link"
                                    />
                                  ))
                                : " "}
                            </AvatarGroup>
                            {topic.discussions_count > 0 ? (
                              <HStack mt="15px">
                                <Image src={comment} />
                                {topic.discussions_count > 1 ? (
                                  <Text>{topic.discussions_count} replies</Text>
                                ) : (
                                  <Text>{topic.discussions_count} reply</Text>
                                )}
                              </HStack>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Flex>
                      ))}
                    </Box>
                  ) : (
                    <Flex
                      height="80vh"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      gap="0.5rem"
                    >
                      <Image
                        src={emptyDiscussion}
                        alt="Empty discussion"
                        height={{
                          lg: "16rem",
                          md: "14rem",
                          sm: "13rem",
                          base: "12rem",
                        }}
                        width={{
                          lg: "16rem",
                          md: "14rem",
                          sm: "13rem",
                          base: "12rem",
                        }}
                      />
                      <Text
                        fontSize={{
                          lg: "36px",
                          md: "28px",
                          sm: "22px",
                          base: "18px",
                        }}
                        fontWeight="600"
                      >
                        No Discussion
                      </Text>
                      <Text
                        fontSize={{ lg: "16px", md: "12px", sm: "11px" }}
                        textAlign="center"
                      >
                        There are no discussions started yet.Click the link{" "}
                        <br></br>above to create a discussion topic and begin
                        discussion
                      </Text>
                    </Flex>
                  )}
                </Box>
              </VStack>
            </Flex>
          </Box>
        </>
      )}
    </>
  );
};

export default TrDiscussions;
